import { useTheme } from '@mui/material';

export const ProformaInvoiceIcon = () => {
    const theme = useTheme();
    const themeSuccessLightColour = theme.palette.success.light;

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 7.33333H6.00004M8.66671 4.66667H6.00004M10 10H6.00004M12.6667 2.66667V14L11.1134 13.3333L9.56004 14L8.00004 13.3333L6.44671 14L4.89337 13.3333L3.33337 14V2.66667C3.33337 2.48986 3.40361 2.32029 3.52864 2.19526C3.65366 2.07024 3.82323 2 4.00004 2H12C12.1769 2 12.3464 2.07024 12.4714 2.19526C12.5965 2.32029 12.6667 2.48986 12.6667 2.66667Z"
                stroke={themeSuccessLightColour}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
